export default "__VITE_ASSET__C3Ey5On2__"